// extracted by mini-css-extract-plugin
export default {"divider":"PageModuleModal_divider__clf3W","buttons":"PageModuleModal_buttons__U5Yeg"};